import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import DayPicker from "react-day-picker";

import dotLoading from "../../../../assets/icons/dotLoading.svg";
import "./styles.scss";

// eslint-disable-next-line react/prop-types
export const DayPicking = ({MONTHS, WEEKDAYS_LONG, WEEKDAYS_SHORT, handleDayClick, selectedDay, ref}) => {

    // const dayPickerRef = useRef(null);
    //
    // useEffect(() => {
    // 	dayPickerRef.current.scrollIntoView({ behavior: "smooth" });
    // }, []);
    const modifiersStyles = {
        selected: {
            color: "white",
            backgroundColor: "#FF6744",
            outline: "none"
        },
        wrapper: {
            outline: "none"
        }
    };

    return (
        <div ref={ref}>
            <DayPicker
                locale="fr"
                months={MONTHS}
                weekdaysLong={WEEKDAYS_LONG}
                weekdaysShort={WEEKDAYS_SHORT}
                onDayClick={handleDayClick}
                selectedDays={selectedDay}
                disabledDays={[
                    {before: new Date(new Date().getTime() + (24 * 60 * 60 * 1000))},
                    {daysOfWeek: [0, 6]}
                ]}
                firstDayOfWeek={1}
                modifiersStyles={modifiersStyles}
            />
        </div>
    );
};

const Messages = ({messages, selectedDay, setSelectedDay, disableDatePicker, botIsLoading}) => {

    const MONTHS = [
        "Janvier",
        "Fevrier",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
    ];
    const WEEKDAYS_LONG = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
    ];
    const WEEKDAYS_SHORT = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];

    const lastListElement = useRef(null);

    useEffect(() => {
        lastListElement.current.scrollIntoView(lastListElement);
    }, [messages, disableDatePicker]);

    const handleDayClick = (day, modifier = {}) => {
        if (modifier.disabled) {
            return;
        }
        modifier.selected ? undefined : setSelectedDay(day);
    };

    return (
        <>
            {
                messages.map((message, index) => {
                    return (
                        <div key={index}>
                            <div className={`${message.type === "user" ? "bulle-droite" : "bulle-gauche"} fade`}>
                                <div
                                    className={`bulleMessage ${message.type === "user" ? "bulleUser" : "bulleCareManager"} fade`}>
                                    {message.message}
                                </div>
                                <span className="date-envoi">{message.date}</span>
                            </div>
                            <div ref={lastListElement}/>
                        </div>
                    );
                })
            }
            {botIsLoading &&
                <div id="dotsMessage">
                    <img src={dotLoading}/>
                </div>
            }
            <div className="spacer-blur"></div>
        </>

    );
};

Messages.propTypes = {
    messages: PropTypes.array,
    selectedDay: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    setSelectedDay: PropTypes.func,
    disableDatePicker: PropTypes.bool,
    botIsLoading: PropTypes.bool,
};

export default Messages;